// export const SOCKET_URL = "https://mazebaan.codestudio.solutions:5000/"; //staging
export const SOCKET_URL = "206.189.27.21:5000"; //stagin ip
// export const SOCKET_URL = "192.168.100.83:5000"; // local junaid bahi

